<template>
  <ion-menu @ionWillOpen="menuOpened()" menu-id="app-menu" content-id="main-content" >
    <ion-header>
      <ion-toolbar>
        <ion-title>Folkwiki</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-list>
        <ion-item button v-if="!currentUser" @click="menuNavigation('/tunes')">
          <ion-label>{{$t('tunes')}}</ion-label>
        </ion-item>
        <ion-item button v-if="currentUser" @click="menuNavigation('/usertunes')">
          <ion-label>{{$t('tunes')}}</ion-label>
        </ion-item>
        <ion-item button @click="menuNavigation('/tunebooks')">
          <ion-label>{{$t('tunebooks')}}</ion-label>
        </ion-item>
        <ion-item button @click="menuNavigation('/musicians')">
          <ion-label>{{$t('musicians')}}</ion-label>
        </ion-item>
        <ion-item button @click="menuNavigation('/statistics')">
          <ion-label>{{$t('statistics')}}</ion-label>
        </ion-item>
        <ion-item button v-if="currentUser" @click="menuNavigation('/groups')">
          <ion-label>{{$t('groups')}}</ion-label>
        </ion-item>
        <ion-item button v-if="currentUser" @click="menuNavigation('/users')">
          <ion-label>{{$t('users')}}</ion-label>
        </ion-item>
        <ion-item button v-if="currentUser" @click="menuNavigation('/playlists')">
          <ion-label>{{$t('playlists')}}</ion-label>
        </ion-item>
        <ion-item button v-if="currentUser" @click="menuNavigation('/sessions')">
          <ion-label>{{$t('sessions')}}</ion-label>
        </ion-item>
        <ion-item button @click="menuNavigation('/documentation')">
          <ion-label>{{$t('documentation')}}</ion-label>
        </ion-item>
        <ion-item button v-if="!isMobile" @click="menuNavigation('/support')">
          <ion-label>{{ currentUser ? $t('donatePremiumMenu') : $t('donateMenu') }}</ion-label>
        </ion-item>
        <ion-item button v-if="!currentUser" @click="menuNavigation('/register')">
          <ion-label>{{$t('signup')}}</ion-label>
        </ion-item>
        <ion-item button v-if="!currentUser" @click="menuNavigation('/login')">
          <ion-label>{{$t('login')}}</ion-label>
        </ion-item>
        <ion-item button v-if="currentUser" @click="menuNavigation('/profile')">
          <ion-label>{{ currentUser.username }}</ion-label>
        </ion-item>
        <ion-item button v-if="currentUser" @click="menuNavigation('/messages')">
          <ion-label>{{$t('messages')}}</ion-label><ion-label v-if="this.unread>0"> ({{this.unread}})</ion-label>
        </ion-item>
        <ion-item button v-if="currentUser" @click="menuNavigation('/settings')">
          <ion-label>{{$t('settings')}}</ion-label>
        </ion-item>
        <ion-item button v-if="showModeratorBoard" @click="menuNavigation('/mod')">
          <ion-label>{{ $t('moderatorBoard') }}</ion-label>
        </ion-item>
        <ion-item button v-if="showAdminBoard" @click="menuNavigation('/admin')">
          <ion-label>{{ $t('admin') }}</ion-label>
        </ion-item>
        <ion-item button v-if="showTestCenter" @click="menuNavigation('/test-center')">
          <ion-label>🧪 Test Center</ion-label>
        </ion-item>
        <ion-item button @click="menuNavigation('/home')">
          <ion-label>{{$t('home')}}</ion-label>
        </ion-item>
        <ion-item button v-if="currentUser" @click.prevent="logOut">
          <ion-label>{{$t('logout')}}</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-menu> 
</template>

<script>
import {
  IonMenu,IonHeader,IonContent,IonToolbar,IonTitle,IonItem,IonList,IonLabel,menuController,isPlatform
} from "@ionic/vue";
import MessageDataService from "../services/MessageDataService";

export default {
  components: {
    IonMenu,IonHeader,IonContent,IonToolbar,IonTitle,IonItem,IonList,IonLabel,
  },
  data() {
    return {
        unread: null,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {      
      if (this.currentUser && this.currentUser.role) {
        //console.log("rolesRob:",  this.currentUser.role); har testat detta, singular role funkar nu här
        return this.currentUser.role.includes('ROLE_ADMIN');
      }            
      return false;      
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser.role) {
        return this.currentUser.role.includes('ROLE_MODERATOR');
      }

      return false;
    },
    showTestCenter() {
      if (this.currentUser && this.currentUser.environment) {
        return this.currentUser.environment === 'test';
      }
      return false;
    },
    //Added 2024-05-07
    loggedIn() {
      return !!this.currentUser;
    },
    //End added 2024-05-07
    isMobile() {
      return isPlatform('android') || isPlatform('ios');
    },
  },
  methods:{
    menuNavigation(url){
      menuController.close("app-menu");
      this.$router.push(url);
    },
    logOut() {
      menuController.close("app-menu");
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    retrieveUnread() {
      if (this.loggedIn && this.currentUser && this.currentUser.id != null) {
        MessageDataService.get(this.currentUser.id)
        .then(response => {
          this.unread = response.data.length;
        })
        .catch(err => {
          console.log(err);
        })
      }
    },
    menuOpened() {
      // Blur any focused element inside the main content before aria-hidden is applied
      if (document.activeElement && document.activeElement !== document.body) {
        document.activeElement.blur();
      }
      if (this.loggedIn) {
        this.retrieveUnread();
      }
    }
  },
  mounted() {
    if (this.loggedIn) {
      this.retrieveUnread();
    }
  },
};
</script>